var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.844 2.59785C25.8571 3.03627 24.795 3.33153 23.6811 3.46484C24.8183 2.78305 25.6916 1.704 26.1022 0.418255C25.0393 1.04994 23.8591 1.50716 22.6056 1.755C21.6008 0.684891 20.1683 0.015625 18.5855 0.015625C15.5443 0.015625 13.0784 2.48153 13.0784 5.52275C13.0784 5.95401 13.1276 6.37454 13.2216 6.77807C8.64408 6.54901 4.58644 4.35601 1.87001 1.024C1.39579 1.83731 1.12469 2.78306 1.12469 3.79233C1.12469 5.7026 2.09548 7.38829 3.57448 8.37608C2.6708 8.34745 1.82258 8.0996 1.07905 7.68713V7.75602C1.07905 10.425 2.97859 12.6502 5.49638 13.1576C5.0347 13.2828 4.54796 13.3508 4.04601 13.3508C3.6908 13.3508 3.34543 13.3159 3.00901 13.2515C3.70959 15.4391 5.74423 17.0318 8.15376 17.0765C6.26944 18.5528 3.8948 19.4342 1.31437 19.4342C0.86879 19.4342 0.43037 19.4082 0 19.3563C2.43727 20.9185 5.33175 21.8312 8.44187 21.8312C18.5712 21.8312 24.1105 13.4394 24.1105 6.16248C24.1105 5.92359 24.1061 5.6856 24.0944 5.45028C25.1717 4.67185 26.1058 3.70195 26.844 2.59785Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f7813e77cc37a64648b270ccef1e6525.svg";
export { ForwardRef as ReactComponent };